import React, { useState, useRef, useEffect } from "react";

import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Banner2 from "../../components/Banner2";
import { ROUTES } from "../../routes/RouterConfig";
import { useNavigate } from "react-router-dom";
import {
  Users,
  CreditCard,
  Shield,
  Award,
  ChevronRight,
  Globe,
  DollarSignIcon,
} from "lucide-react";
const About = () => {
  document.title = "Teamlancer";
  const navigate = useNavigate();

  return (
    <div id="NewHome">
      <Header />
      <Banner2 />
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
        {/* Our Mission */}
        <section className="w-full py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col md:flex-row items-center gap-10">
              <div className="md:w-1/2">
                <h2 className="text-3xl font-bold mb-6 text-gray-800">
                  Who We Are
                </h2>
                <p className="text-lg text-gray-600 mb-4">
                  <a href="teamlancer.xyz">Teamlancer.xyz</a> is a Web3-native
                  freelance platform founded by entrepreneurs who’ve worked in
                  startups, marketing, and blockchain. We saw the need for a
                  smarter way to scale, one built for real projects, real
                  outcomes, and real collaboration.
                </p>
                <p className="text-lg text-gray-600">
                  Whether you’re launching a campaign, building your brand, or
                  deploying a new tech stack, Teamlancer is where serious
                  builders find serious teams.
                </p>
              </div>
              <div className="md:w-1/2 flex justify-center">
                <div className="bg-blue-500 rounded-full p-12">
                  <Shield size={120} className="text-white" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Crypto Payments */}
        <section className="w-full py-16 px-4 bg-white">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold mb-3 text-center text-gray-800">
              Why Crypto Payments?
            </h2>
            <p className="text-lg font-normal mb-12 text-center text-gray-600">
              Freelancers and businesses are global payments should be too. With
              crypto payments, you get:
            </p>
            <div className="grid md:grid-cols-4 gap-4">
              <div className="bg-gray-50 px-4 py-8 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 text-blue-600 mb-6">
                  <CreditCard size={28} />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-gray-800">
                  Faster transactions
                </h3>
                <p className="text-gray-600">
                  Faster transactions—no more waiting days for wires to clear
                </p>
              </div>

              <div className="bg-gray-50 px-4 py-8 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 text-blue-600 mb-6">
                  <Shield size={28} />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-gray-800">
                  Enhanced Security
                </h3>
                <p className="text-gray-600">
                  Full transparency and verifiable on-chain history
                </p>
              </div>

              <div className="bg-gray-50 px-4 py-8 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 text-blue-600 mb-6">
                  <Globe size={28} />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-gray-800">
                  Global Accessibility
                </h3>
                <p className="text-gray-600">
                  Global accessibility—work with anyone, anywhere, without the
                  banking friction
                </p>
              </div>
              <div className="bg-gray-50 px-4 py-8 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 text-blue-600 mb-6">
                  <DollarSignIcon size={28} />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-gray-800">
                  Lower Fees
                </h3>
                <p className="text-gray-600">
                  Lower fees compared to traditional payment processors
                </p>
              </div>
            </div>

            <div className="mt-8 text-left">
              <p className=" text-black text-lg font-medium py-3 rounded-md transition-colors">
                Crypto isn’t just a trend it’s the backbone of a trustless,
                borderless digital economy. And we’ve built Teamlancer to run
                right alongside it.
              </p>
            </div>
          </div>
        </section>

        {/* Our Team */}
        <section className="w-full py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col md:flex-row items-center gap-10">
              <div className="md:w-1/2 flex justify-center order-2 md:order-1">
                <div className="bg-blue-100 rounded-lg p-8">
                  <Users size={120} className="text-blue-600" />
                </div>
              </div>
              <div className="md:w-1/2 order-1 md:order-2">
                <h2 className="text-3xl font-bold mb-6 text-gray-800">
                  Why Team Matters
                </h2>
                <p className="text-lg text-gray-600 mb-4">
                  Most platforms are built for hiring individuals. But serious
                  results come from collaboration designers, devs, marketers,
                  and strategists who already know how to work together.
                </p>
                <p className="text-lg text-gray-600 mb-6">
                  With Teamlancer, you can hire a team that moves faster,
                  communicates better, and ships complete solutions not just
                  fragments of a project.
                </p>
                <div className="flex items-center">
                  <div className="mr-4">
                    <Award size={32} className="text-blue-600" />
                  </div>
                  <p className="text-gray-700 font-medium">
                    Named among "Top 50 Fintech Innovators" by Financial Times
                    in 2024
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="w-full py-20 px-4 bg-blue-800 text-white">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">
              Ready to Transform Your Payment Experience?
            </h2>
            <p className="text-xl text-indigo-100 max-w-2xl mx-auto mb-8">
              Join thousands of forward-thinking businesses already using
              CryptoFlow's solutions.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <button
                onClick={() => navigate(ROUTES.Connect)}
                className="bg-white text-indigo-900 hover:bg-gray-100 font-medium py-3 px-8 rounded-md transition-colors"
              >
                Explore More
              </button>
              <button
                onClick={() => navigate(ROUTES.About)}
                className="bg-transparent border-2 border-white hover:bg-indigo-800 text-white font-medium py-3 px-8 rounded-md transition-colors"
              >
                Learn More
              </button>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default About;
